const STORAGE_KEY = "conversation:analytics"

export type ConversationAnalyticsSnapshot = {
  sessionId: string
  startedAt: number
  turnsStarted: number
  aiResponses: number
  goalAchieved: boolean
  errorBlocking: boolean
}

type AnalyticsStorage = Pick<Storage, "getItem" | "setItem" | "removeItem"> | undefined

export const readAnalytics = (storage: AnalyticsStorage, sessionId: string): ConversationAnalyticsSnapshot | null => {
  if (!storage) return null
  let parsed: unknown
  try {
    const raw = storage.getItem(STORAGE_KEY)
    if (!raw) return null
    parsed = JSON.parse(raw)
  } catch {
    return null
  }
  if (!parsed || typeof parsed !== "object") return null
  const obj = parsed as Record<string, unknown>
  if (obj.sessionId !== sessionId) return null
  if (typeof obj.startedAt !== "number" || !Number.isFinite(obj.startedAt)) return null
  return {
    sessionId,
    startedAt: obj.startedAt,
    turnsStarted: typeof obj.turnsStarted === "number" ? obj.turnsStarted : 0,
    aiResponses: typeof obj.aiResponses === "number" ? obj.aiResponses : 0,
    goalAchieved: obj.goalAchieved === true,
    errorBlocking: obj.errorBlocking === true,
  }
}

export const writeAnalytics = (storage: AnalyticsStorage, snapshot: ConversationAnalyticsSnapshot): void => {
  if (!storage) return
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(snapshot))
  } catch {
    // best-effort
  }
}

export const clearAnalytics = (storage: AnalyticsStorage): void => {
  if (!storage) return
  try {
    storage.removeItem(STORAGE_KEY)
  } catch {
    // best-effort
  }
}
